const DEFAULT_API_BASE_LOCAL = 'http://localhost:9090/api';
const DEFAULT_API_BASE_PROD = 'https://residenthood.appspot.com/api';

const resolveApiBase = () => {
	const fromEnv = process.env.REACT_APP_API_BASE?.trim();
	if (fromEnv) {
		return fromEnv;
	}

	if (process.env.NODE_ENV === 'development') {
		return DEFAULT_API_BASE_LOCAL;
	}

	return DEFAULT_API_BASE_PROD;
};

const getOrigin = (apiBase: string) => {
	try {
		return new URL(apiBase).origin;
	} catch {
		return apiBase.replace(/\/api\/?$/, '');
	}
};

export const API_BASE = resolveApiBase();
export const AUTH_BASE = `${API_BASE}/auth`;
export const ADMIN_BASE = `${getOrigin(API_BASE)}/admin`;